var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLatPerfilA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.14,
    height: 16.014,
    viewBox: "0 0 15.14 16.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-431.802 -223.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1268.914,80.411a3.344,3.344,0,1,1-3.35-3.337A3.335,3.335,0,0,1,1268.914,80.411Z",
    transform: "translate(-826.314 147.602)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.809,213.295h-4.352a2.486,2.486,0,0,1-1.276-.289,1.778,1.778,0,0,1-.92-1.581,9.2,9.2,0,0,1,.529-3.605,3.5,3.5,0,0,1,.763-1.22,2.2,2.2,0,0,1,1.516-.63.313.313,0,0,1,.163.058c.238.148.473.3.709.452a5.224,5.224,0,0,0,3.26.866,5.289,5.289,0,0,0,2.419-.809c.268-.167.53-.345.8-.508a.432.432,0,0,1,.234-.053,2.311,2.311,0,0,1,1.981,1.357,6.612,6.612,0,0,1,.685,2.447c.052.468.07.941.076,1.411a1.915,1.915,0,0,1-2.039,2.1c-1.516.016-3.032,0-4.549,0Z",
    transform: "translate(-769.455 25.393)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatPerfilA);
export default __webpack_public_path__ + "static/media/LAT-PERFIL-A.93e3bedb8235779b302174aea58b4d86.svg";
export { ForwardRef as ReactComponent };